import { FC, ReactElement } from "react";

import {
  BulkGridSelectionControl,
  EditGridColumnButton,
  PanelTopStatCommon,
  StationsMapToggleButton,
} from "@ryde/layout";
import { usePageContext } from "@ryde/redux";
import { isEntityWithoutBulkActions, useIsMobile } from "@ryde/shared";

import { StationsPanelTopWrapper } from "./parts";

interface IStationsPanelTopProps {
  StartAddition?: ReactElement;
  PanelTopStatCommonReplacement?: ReactElement;
}

export const StationsPanelTop: FC<IStationsPanelTopProps> = ({
  StartAddition,
  PanelTopStatCommonReplacement,
}) => {
  const { entity } = usePageContext();
  const { isMobile } = useIsMobile();
  const showBulkGridSelection = !isEntityWithoutBulkActions(entity);

  if (isMobile) {
    return null;
  }

  return (
    <StationsPanelTopWrapper>
      {showBulkGridSelection && <BulkGridSelectionControl />}
      {!isMobile && <StationsMapToggleButton />}

      <div className="panelTopRight">
        {Boolean(StartAddition) && StartAddition}
        {Boolean(PanelTopStatCommonReplacement) &&
          PanelTopStatCommonReplacement}
        {!PanelTopStatCommonReplacement && <PanelTopStatCommon />}
        <EditGridColumnButton />
      </div>
    </StationsPanelTopWrapper>
  );
};
